<template>
    <div v-if="error" class="error--text caption text-left mb-5">
        {{error}}<slot></slot>
    </div>
</template>

<script>
    export default {
        name: "error-msg",
        props: ["error"]
    }
</script>

<style scoped>

</style>